import { render } from "./TableDepartmentsProjectsUser.vue?vue&type=template&id=125f9cf6&scoped=true"
import script from "./tabledepartmentsprojectsuser.view.js?vue&type=script&lang=js&external"
export * from "./tabledepartmentsprojectsuser.view.js?vue&type=script&lang=js&external"

import "./tabledepartmentsprojectsuser.css?vue&type=style&index=0&id=125f9cf6&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-125f9cf6"]])

export default __exports__